import { Component } from '@angular/core';

@Component({
	selector: 'app-ea-spinner',
	templateUrl: './spinner.component.html',
})
export class SpinnerComponent {}
